import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

// Cadastro de profissional servido pelo quarkus.
export function useSaveProfessional() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((professional) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = professional.id
      ? quarkusApi.put('/dentista', professional, authHeader)
      : quarkusApi.post('/dentista', professional, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
